export default {
    points: [
        { x: 3, y: 97.52 },
        { x: 4, y: 105.30 },
        { x: 5, y: 102.97 },
        { x: 6, y: 111.93 },
        { x: 7, y: 114.57 },
        { x: 8, y: 110.98 },
    ],
    yTicks: [0, 25, 50, 75, 100, 125, 150, 175, 200]
}